import { Typography } from "@material-ui/core";
import React from "react";

import { MimeTypes } from "../backend/types/utils";
import { CommonButton } from "./index";

export const CommonFileUpload = ({
  id,
  values,
  errors,
  touched,
  setFieldValue,
  disabled,
  buttonText,
  stateText,
}: any) => {
  // Hooks
  const hiddenFileInput = React.useRef<HTMLInputElement>(null);

  // Helpers
  const handleClick = () => {
    if (hiddenFileInput !== null &&
        hiddenFileInput.current !== null) {
      hiddenFileInput.current.click();
    }
  };

  const allowedTypes = Object.values(MimeTypes);

  return (
    <>
      <CommonButton
        onClick={handleClick}
        disabled={disabled}
        values={values}
        errors={errors}
        touched={touched}
        text={buttonText}
      />

      <Typography>
        {values[id].length} {stateText}
      </Typography>

      <input
        type="file"
        accept={allowedTypes.join(',')}
        ref={hiddenFileInput}
        style={{ display: 'none' }}
        multiple
        required
        onChange={({
          target: {
            validity, files: newFiles
          }
        }) => {
          if (validity.valid && newFiles) {
            let allFiles = [...values[id]];
            allFiles = allFiles.concat(Array.from(newFiles).filter((file: any) => allowedTypes.includes(file.type)));
            setFieldValue(
              id,
              allFiles
            );
          }
        }}
      />
    </>
  );
}